import Vue from 'vue';
import _ from 'lodash';

export default {
  SET_DNT_LIST(state, payload) {
    // TODO: test clean the list state before.
    state.list = (payload.documentos || [])
      .reduce((index, option) => ({
        ...index,
        [option.febosId]: option
      }), {});
    state.pagination = {
      items: Number.parseInt(payload.totalElementos, 10),
      pages: Number.parseInt(payload.totalPaginas, 10)
    };
  },
  UPDATE_SELECTED_FLOWS(state, selectAll) {
    Object.keys(state.trays).forEach((flow) => {
      state.trays[flow].selected = selectAll;
    });
  },
  UPDATE_SELECTED_FLOW(state, { id, selected }) {
    state.trays[id].selected = selected;
  },
  SET_LOADING(state, payload) {
    state.loading = payload;
  },
  SET_LOADING_ATTACHMENTS(state, payload) {
    state.loadingAttachments = payload;
  },
  SET_LOADING_BINNACLE(state, payload) {
    state.loadingBinnacle = payload;
  },
  SET_ERROR_MESSAGE(state, payload) {
    state.error = payload;
  },
  CLOSE_MODAL(state, payload) {
    state.showModal = payload;
  },
  SET_TRAY(state, payload) {
    state.trays = (payload.aprobaciones || [])
      .map((element) => ({
        ...element,
        selected: false
      }))
      .reduce((index, option) => ({
        ...index,
        [option.idAprobacion]: option
      }), {});
    state.pagination = {
      items: Number.parseInt(payload.totalElementos, 10),
      pages: Number.parseInt(payload.totalPaginas, 10)
    };
  },
  SET_TRAY_SEARCH(state, payload) {
    state.trays = (payload.documentos || [])
      .map((element) => ({
        ...element,
        selected: false
      }))
      .reduce((index, option) => ({
        ...index,
        [option.idAprobacion]: option
      }), {});
    state.pagination = {
      items: Number.parseInt(payload.totalElementos, 10),
      pages: Number.parseInt(payload.totalPaginas, 10)
    };
  },
  UPDATE_CANCELED_FILE(state, idAprobacion) {
    state.trays[idAprobacion].aprobacionesEjecucionEstadoId = 6;
  },
  UPDATE_RETAIN_FILE(state, idAprobacion) {
    state.trays[idAprobacion].retenido = 'Y';
  },
  UPDATE_DISPARAGE_FILE(state, idAprobacion) {
    state.trays[idAprobacion].aprobacionesEjecucionEstadoId = 1;
  },
  SET_BINNACLE(state, payload) {
    state.binnacle = payload;
  },
  SET_FILE_ON_FLOW(state, payload) {
    state.fileOnFlow = payload;
  },
  SET_ATTACHMENTS(state, payload) {
    state.fileOnFlowAttachments = payload;
  },
  UPDATE_FILE_ON_FLOW(state, payload) {
    const comment = {
      ...payload.comentario,
      documentos: payload.documentos
    };

    state.fileOnFlow.detalle.ejecucion.comentarios.push(comment);
    const documents = payload.documentos
      .map((document) => ({
        ...document,
        url: document.adjuntoUrl
      }));
    state.fileOnFlowAttachments = state.fileOnFlowAttachments.concat(documents);
  },
  SET_SELECTED_FILE(state, payload) {
    state.selectedFile = payload;
  },
  SET_PROCESS_DOCUMENT(state, payload) {
    state.processType = payload;
  },
  SET_LOADING_NUMERATION(state, payload) {
    state.loadingNumeration = payload;
  },
  SET_NUMERATION_DNT(state, payload) {
    state.numerationFile = payload.folioDescripcion || '';
    state.numerationFebosId = payload.febosId || '';
  },
  SET_WIZARD_DATA(state, payload) {
    state.wizardData = payload;
  },
  UPDATE_WIZARD_DATA(state, url) {
    state.wizardData = {
      ...state.wizardData,
      fileUrl: url
    };
  },
  ADD_WIZARD_DATA(state, payload) {
    state.wizardData = {
      ...state.wizardData,
      ...payload
    };
  },
  MERGE_WIZARD_DATA(state, payload) {
    state.wizardData = _.merge(state.wizardData, payload);
  },
  CLEAR_WIZARD_DATA(state) {
    state.wizardData = {};
  },
  SET_APPROVALS_DASHBOARD(state, payload) {
    const approvals = payload.lista;
    const approvalsList = approvals
      .filter((approval) => approval.estado
        && (approval.estado === 'INICIADA' || approval.estado === 'INICIADA'));
    const indicators = [
      {
        id: '3',
        title: 'Flujos Desestimados',
        count: payload.resumen.desestimados,
        color: 'light-warning',
        icon: 'XCircleIcon'
      },
      {
        id: '2',
        title: 'Flujos Rechazados',
        count: payload.resumen.rechazados,
        color: 'light-danger',
        icon: 'ThumbsDownIcon'
      },
      {
        id: '1',
        title: 'Flujos Anulados',
        count: payload.resumen.anulados,
        color: 'light-danger',
        icon: 'ClockIcon'
      },
      {
        id: '0',
        title: 'Flujos Aprobados',
        count: payload.resumen.aprobados,
        color: 'light-success',
        icon: 'ThumbsUpIcon'
      }
    ];
    state.dashboard.approvals = approvals;
    state.dashboard.approvalsList = approvalsList;
    state.dashboard.resume = payload.resumen;
    state.dashboard.indicators = indicators;
  },
  SET_FLOW_DASHBOARD(state, payload) {
    state.dashboard.flow = payload;
  },
  SET_FLOW_DASHBOARD_LOADING(state, payload) {
    state.dashboard.loading = payload;
  },
  SET_REFERENCE_APPROVALS(state, payload) {
    state.referenceApprovals = payload;
  },
  SET_APPROVALS(state, payload) {
    state.approvalsTemplates = payload;
  },
  SET_PAGINATION_DATA(state, payload) {
    state.templatePaginationData = payload;
  },
  SET_PURCHASE_TYPE(state, payload) {
    state.purchaseTypes = payload;
  },
  SET_CATEGORIES(state, payload) {
    state.categoryOptions = payload;
  },
  SET_DOCUMENTS(state, payload) {
    state.documentOptions = payload;
  },
  SET_PURCHASE_TYPES(state, payload) {
    state.purchaseTypeOptions = payload;
  },
  SET_REPORT_TYPES(state, payload) {
    state.reportTypeOptions = payload;
  },
  SET_CONSEQUENCES(state, payload) {
    state.consequenceOptions = payload;
  },
  SET_STEP_TYPES(state, payload) {
    state.stepTypes = payload;
  },
  SET_STEP_ROLES(state, payload) {
    state.stepRoles = payload;
  },
  SET_APPROVAL_TEMPLATE(state, payload) {
    state.aprovalTemplate = payload;
  },
  REMOVE_SIGNATURES_DROPPED(state) {
    if (state.wizardData.signaturesDropped) {
      Vue.set(state.wizardData, 'signaturesDropped', {});
    }
  },
  SET_INFO_CU(state, payload) {
    state.infoCU = payload;
  },
  SET_DOCUMENT_TYPE_REFERENCES(state, payload) {
    state.documentTypeReferences = payload;
  }
};
